import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    body: "Arial, sans-serif",
    heading: "Arial, sans-serif",
  },
});

export default theme;
